var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 3C6 2.44772 6.44772 2 7 2H17C17.5523 2 18 2.44772 18 3V5.34315C18 6.66923 17.4732 7.941 16.5355 8.87868L12.7071 12.7071C12.3166 13.0976 11.6834 13.0976 11.2929 12.7071L7.46446 8.87868C6.52678 7.941 6 6.66923 6 5.34315V3ZM8 4V5.34315C8 6.1388 8.31607 6.90186 8.87868 7.46446L12 10.5858L15.1213 7.46447C15.6839 6.90186 16 6.1388 16 5.34315V4H8Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 21C18 21.5523 17.5523 22 17 22H7C6.44771 22 6 21.5523 6 21V18.6569C6 17.3308 6.52678 16.059 7.46447 15.1213L11.2929 11.2929C11.6834 10.9024 12.3166 10.9024 12.7071 11.2929L16.5355 15.1213C17.4732 16.059 18 17.3308 18 18.6569V21ZM16 20V18.6569C16 17.8612 15.6839 17.0981 15.1213 16.5355L12 13.4142L8.87868 16.5355C8.31607 17.0981 8 17.8612 8 18.6569V20H16Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.908 19H13.092C13.5935 19 14 18.5935 14 18.092C14 17.8225 13.8803 17.5669 13.6733 17.3944L12.6402 16.5335C12.2693 16.2244 11.7307 16.2244 11.3598 16.5335L10.3267 17.3944C10.1197 17.5669 10 17.8225 10 18.092C10 18.5935 10.4065 19 10.908 19Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.9e097559b6f784a40c0ffc102933a8d4.svg";
export { ForwardRef as ReactComponent };